<template>
  <v-card
    class="mx-auto my-8"
    style="padding: 10px"
    width="90%"
    height="auto"
    elevation="16"
  >
    <v-card-text align="center">
      <p class="txtinfo">Acerca de Nosotros</p>
      <divider-component />
      <br />
      <p class="txtdescripciones">
        CASA CRU S.A. DE C.V, parte del Grupo Cruz Azul, líderes en construcción
        y gestión de obras desde 1991. Nos destacamos por brindar servicios
        integrales que van más allá de la construcción, incluyendo asesoría,
        supervisión y administración eficiente. Con un enfoque en la excelencia
        y la satisfacción del cliente, nuestro equipo altamente capacitado se
        compromete a ofrecer proyectos de calidad, a tiempo y dentro del
        presupuesto. Construimos más que estructuras; construimos relaciones
        sólidas basadas en transparencia, integridad y entrega confiable.
      </p>

      <v-container>
        <v-row>
          <v-col sm="12" md="6" lg="6">
            <p class="txtinfo">Misión</p>
            <divider-component />
            <p class="txtdescripciones">
              Proveer servicios y productos de la construcción cumpliendo las
              expectativas de nuestros clientes
            </p>
          </v-col>

          <v-col sm="12" md="6" lg="6">
            <div>
              <p class="txtinfo">Visión</p>
              <divider-component />
              <p class="txtdescripciones">
                Lograr el crecimiento y consolidación a fin de mantener el
                liderazgo regional, procurando la participación en el mercado
                nacional
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <p class="txtinfo">Valores</p>
      <divider-component />
      <br />
      <div class="custom-bullets">
        <ul>
          <li class="txtdescripciones">Trabajo en equipo.</li>
          <li class="txtdescripciones">Compromiso.</li>
          <li class="txtdescripciones">Respeto.</li>
          <li class="txtdescripciones">Honestidad</li>
        </ul>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import DividerComponent from '@/components/DividerComponent.vue';
export default {
  components: { DividerComponent },
  data() {
    return {};
  },
};
</script>

<style scoped>
.txtinfo {
  padding-top: 2rem;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 2rem;
  font-weight: 800;
  color: #1c3e8e;
  line-height: 1;
}
.txtdescripciones {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  color: black;
}

@media (min-width: 1200px) {
  /* Ajusta este valor según el breakpoint que desees */
}

@media (max-width: 1199px) {
}

/* Viñetas personalizadas */
.custom-bullets ul {
  list-style-type: none;
  padding-left: 0;
}

.custom-bullets ul li::before {
  content: '🔸'; /* Carácter personalizado para la viñeta */
  color: blue; /* Color de la viñeta */
  padding-right: 5px; /* Espacio entre la viñeta y el texto */
}
</style>
